module.exports = __webpack_public_path__ + "img/Artxboard – 2.16be9b8d.png";